import { Divider, Row } from "antd";
import Text from "@/components/common/Typography/Text";
import { useIsDesktop } from "@/hooks/app/useIsDesktop";
import Link from "@/components/common/LinkNext";
import { useTranslation } from "react-i18next";

type SignupFormFooterProps = {
  onSwitchToLogin?: () => void;
};

const SignupFormFooter = ({ onSwitchToLogin }: SignupFormFooterProps) => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation()
  
  return (
    <Row justify="center" className="form-login--noaccount">
      <Divider style={{ marginBottom: "1.6rem", marginTop: 0 }} />
      <Text>
        {t("auth.login_prompt")}{" "}
        {isDesktop ? (
          <a
            onClick={(e) => {
              e.preventDefault();
              if (onSwitchToLogin) {
                onSwitchToLogin();
              }
            }}
            style={{ cursor: "pointer" }}
          >
            {t("common.login")}
          </a>
        ) : (
          <Link href="/login">{t("common.login")}</Link>
        )}
      </Text>
    </Row>
  );
};

export default SignupFormFooter;